import moment from 'moment'

function formatTime(value, datetimeFormat) {
  if (!value)
    return '—'
  const m = moment(value)
  return m.isValid() ? m.format(datetimeFormat || 'MM/DD/YYYY hh:mm A') : String(value)
}

function formatMileage(value) {
  if (value == null || value === '')
    return '—'
  return String(value)
}

function bookingStatusMessage(booking) {
  if (!booking)
    return ''
  return String(booking._status_msg_base || booking.status_msg || '').trim()
}

export function buildBookingDetailCm(booking, datetimeFormat, resourceType) {
  const actual = (booking && booking.actual) || {}
  const isVehicle = resourceType === 'vehicle'
  return {
    key: (booking && (booking.bookingID || booking.charterID)) || Math.random(),
    charter_id: booking && booking.charterID,
    driver: booking && booking.driver,
    vehicle_id: booking && booking.vehicle,
    planned_start: formatTime(booking && booking.start_datetime, datetimeFormat),
    planned_finish: formatTime(booking && booking.finish_datetime, datetimeFormat),
    actual_start: formatTime(
      isVehicle ? actual.nearestLocationStartDateTime : actual.nearestLoginStartDateTime,
      datetimeFormat
    ),
    actual_finish: formatTime(
      isVehicle ? actual.nearestLocationFinishDateTime : actual.nearestLogoutFinishDateTime,
      datetimeFormat
    ),
    planned_mileage: formatMileage(booking && booking.plannedDistance),
    actual_mileage: formatMileage(actual.actualTotalDistance),
    status: booking && booking.status,
    status_msg: bookingStatusMessage(booking),
  }
}

export function buildBookingDetailTbn(booking, datetimeFormat, resourceType) {
  const actual = (booking && booking.actual) || {}
  const isVehicle = resourceType === 'vehicle'
  return {
    key: (booking && booking.bookingID) || Math.random(),
    charter_id: booking && booking.bookingID,
    driver: booking && booking.driver,
    vehicle_id: booking && booking.vehicle,
    planned_start: formatTime(booking && booking.start_datetime, datetimeFormat),
    planned_finish: formatTime(booking && booking.finish_datetime, datetimeFormat),
    actual_start: formatTime(
      isVehicle ? actual.actualStartLocationTime : actual.actualClockInTime,
      datetimeFormat
    ),
    actual_finish: formatTime(
      isVehicle ? actual.actualFinishLocationTime : actual.actualClockOutTime,
      datetimeFormat
    ),
    planned_mileage: '—',
    actual_mileage: formatMileage(actual.actualTotalDistance),
    status: booking && booking.status,
    status_msg: bookingStatusMessage(booking),
  }
}

export function buildBookingDetailsFromSegments(segments, variant, datetimeFormat, resourceType) {
  const build = variant === 'tbn' ? buildBookingDetailTbn : buildBookingDetailCm
  const seen = new Set()
  const details = []
  for (const seg of segments) {
    if (!seg || !seg.booking)
      continue
    const key = seg.booking.bookingID || seg.booking.charterID || seg.booking_id
    if (seen.has(key))
      continue
    seen.add(key)
    details.push(build(seg.booking, datetimeFormat, resourceType))
  }
  return details
}

export function panelPositionFromEvent(event, panelWidth, panelHeight) {
  const margin = 12
  const maxW = panelWidth || 360
  const maxH = panelHeight || 280
  let left = event.clientX + margin
  let top = event.clientY + margin
  if (typeof window !== 'undefined') {
    if (left + maxW > window.innerWidth - margin)
      left = Math.max(margin, event.clientX - maxW - margin)
    if (top + maxH > window.innerHeight - margin)
      top = Math.max(margin, event.clientY - maxH - margin)
  }
  return { top: top + 'px', left: left + 'px' }
}
